var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartSeperatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 601.9 20.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00000a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2,2.7L0,.06v-.06h1.9l1.66,2.7h-1.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.6,2.7L13.6.06v-.06h1.9l1.66,2.7h-1.56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.14,9.64l-.08-2.62.42-2.94h1.72l-.42,2.94-.82,2.62h-.82Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.1,13.32l.26-1.86h5.08l-.26,1.86h-5.08Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m53.3,17.8l.34-2.48h2.62l-.36,2.48h-2.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m66.54,20.7l.04-.26c.43-.41.76-.84,1.01-1.28.25-.44.4-.89.47-1.36h-1l.38-2.72h2.28l-.34,2.34c-.08.59-.26,1.16-.53,1.73-.27.57-.64,1.08-1.11,1.55h-1.2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m76.44,20.38l.2-1.44h10l-.2,1.44h-10Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m93.74,20.7l.04-.26c.43-.41.76-.84,1.01-1.28.25-.44.4-.89.47-1.36h-1l.38-2.72h2.28l-.34,2.34c-.08.59-.26,1.16-.53,1.73-.27.57-.64,1.08-1.11,1.55h-1.2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.7,17.8l.34-2.48h2.62l-.36,2.48h-2.6Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.7,13.32l.26-1.86h5.08l-.26,1.86h-5.08Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m136.94,9.64l-.08-2.62.42-2.94h1.72l-.42,2.94-.82,2.62h-.82Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m151.6,2.7l-2-2.64v-.06h1.9l1.66,2.7h-1.56Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m165.2,2.7l-2-2.64v-.06h1.9l1.66,2.7h-1.56Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m177.74,9.64l-.08-2.62.42-2.94h1.72l-.42,2.94-.82,2.62h-.82Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m188.7,13.32l.26-1.86h5.08l-.26,1.86h-5.08Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m202.9,17.8l.34-2.48h2.62l-.36,2.48h-2.6Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m216.14,20.7l.04-.26c.43-.41.76-.84,1.01-1.28.25-.44.4-.89.47-1.36h-1l.38-2.72h2.28l-.34,2.34c-.08.59-.26,1.16-.53,1.73-.27.57-.64,1.08-1.11,1.55h-1.2Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m226.04,20.38l.2-1.44h10l-.2,1.44h-10Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m243.34,20.7l.04-.26c.43-.41.76-.84,1.01-1.28.25-.44.4-.89.47-1.36h-1l.38-2.72h2.28l-.34,2.34c-.08.59-.26,1.16-.53,1.73-.27.57-.64,1.08-1.11,1.55h-1.2Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m257.3,17.8l.34-2.48h2.62l-.36,2.48h-2.6Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m267.38,15.66l.24-1.64h10.24l-.24,1.64h-10.24Zm.6-4.24l.22-1.62h10.24l-.22,1.62h-10.24Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m286.54,9.64l-.08-2.62.42-2.94h1.72l-.42,2.94-.82,2.62h-.82Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m301.2,2.7l-2-2.64v-.06h1.9l1.66,2.7h-1.56Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m314.8,2.7l-2-2.64v-.06h1.9l1.66,2.7h-1.56Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m327.34,9.64l-.08-2.62.42-2.94h1.72l-.42,2.94-.82,2.62h-.82Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m338.3,13.32l.26-1.86h5.08l-.26,1.86h-5.08Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m352.5,17.8l.34-2.48h2.62l-.36,2.48h-2.6Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m365.74,20.7l.04-.26c.43-.41.76-.84,1.01-1.28.25-.44.4-.89.47-1.36h-1l.38-2.72h2.28l-.34,2.34c-.08.59-.26,1.16-.53,1.73-.27.57-.64,1.08-1.11,1.55h-1.2Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m375.64,20.38l.2-1.44h10l-.2,1.44h-10Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m392.94,20.7l.04-.26c.43-.41.76-.84,1.01-1.28.25-.44.4-.89.47-1.36h-1l.38-2.72h2.28l-.34,2.34c-.08.59-.26,1.16-.53,1.73-.27.57-.64,1.08-1.11,1.55h-1.2Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m406.9,17.8l.34-2.48h2.62l-.36,2.48h-2.6Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m419.9,13.32l.26-1.86h5.08l-.26,1.86h-5.08Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m436.14,9.64l-.08-2.62.42-2.94h1.72l-.42,2.94-.82,2.62h-.82Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m450.8,2.7l-2-2.64v-.06h1.9l1.66,2.7h-1.56Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m464.4,2.7l-2-2.64v-.06h1.9l1.66,2.7h-1.56Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m476.94,9.64l-.08-2.62.42-2.94h1.72l-.42,2.94-.82,2.62h-.82Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m487.9,13.32l.26-1.86h5.08l-.26,1.86h-5.08Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m502.1,17.8l.34-2.48h2.62l-.36,2.48h-2.6Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m515.34,20.7l.04-.26c.43-.41.76-.84,1.01-1.28.25-.44.4-.89.47-1.36h-1l.38-2.72h2.28l-.34,2.34c-.08.59-.26,1.16-.53,1.73-.27.57-.64,1.08-1.11,1.55h-1.2Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m525.24,20.38l.2-1.44h10l-.2,1.44h-10Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m542.54,20.7l.04-.26c.43-.41.76-.84,1.01-1.28.25-.44.4-.89.47-1.36h-1l.38-2.72h2.28l-.34,2.34c-.08.59-.26,1.16-.53,1.73-.27.57-.64,1.08-1.11,1.55h-1.2Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m556.5,17.8l.34-2.48h2.62l-.36,2.48h-2.6Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m566.58,15.66l.24-1.64h10.24l-.24,1.64h-10.24Zm.6-4.24l.22-1.62h10.24l-.22,1.62h-10.24Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m585.74,9.64l-.08-2.62.42-2.94h1.72l-.42,2.94-.82,2.62h-.82Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m600.56,6.02l-1.56-3.28.02-.06h1.78l1.1,3.34h-1.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartSeperatorIcon);
export default __webpack_public_path__ + "static/media/cart-seperator-icon.35720add5d06b4fe395149705dd5fe57.svg";
export { ForwardRef as ReactComponent };